module.exports = __webpack_public_path__ + "img/horizontal_4_4_pp2_7016.f277908a.png";